import moment from 'moment'

function convertDate(date) {
  return moment(date).format('DD-MM-YYYY')
}

function convertDateTime(dateTime) {
  return moment(dateTime).format('DD-MM-YYYY, HH:mm')
}

function convertMilisecond(ms) {
  return new Date(ms).getTime()
}

function convertCode(text) {
  if (text) {
    return text.replace(text.substring(3, 8), '***')
  }
}

export { convertDate, convertDateTime, convertMilisecond, convertCode }
